module.exports = __webpack_public_path__ + "img/manager-old.fb79d949.jpg";